import React from "react";
import TextField from "@mui/material/TextField";

const TextInput = ({
  labelName,
  isDisable,
  id,
  type,
  error,
  placeholder,
  helperText,
  size,
  name,
  value,
  onChange,
  varient,
  formPlaceholder,
  shrink,
  animation,
  requiredStar,
}) => {
  return (
    <div>
      <label className="input-label my-2" name={helperText}>
        {labelName}
        {requiredStar ? null : <span style={{ color: "red" }}>*</span>}
      </label>
      <TextField
        // autoComplete={"off"}
        disabled={isDisable ? true : false}
        helperText={helperText}
        error={error}
        placeholder={formPlaceholder}
        InputLabelProps={{ shrink: shrink }}
        InputProps={{
          disableanimation: animation,
          autoComplete: "new-password",
        }}
        fullWidth
        id={id}
        size={size}
        name={name}
        label={placeholder}
        variant={varient}
        value={value}
        onChange={onChange}
        type={type}
      />
    </div>
  );
};

export default TextInput;
